import type { GiftCard, GiftCardFormType, GiftCardListItem } from '@/types'

import Model from './Model'

type FormType = GiftCardFormType
type ListItemType = GiftCardListItem
type SingleType = GiftCard

type Type = FormType | ListItemType | SingleType

export default class GiftCardModel extends Model {
  static model: FormType = {
    id: null,

    name: null,
    date: null,
    description: null,
    price: null,
    sum: null,
    phone: null,
    type: null,
    url: null,

    active: false,
    paid: 0,
  }

  static get() {
    return super.get() as FormType
  }

  static prepareWith<T = Type>(model: T) {
    return super.prepareWith(model) as FormType
  }

  static reset<F = Type, S = Type>(formModel: F, snapshot?: S) {
    return super.reset(formModel, snapshot) as F & S
  }

  static mergeTogether<T = Type>(model: T) {
    return super.mergeTogether(model) as Type
  }

  static mergeTogetherAndCutExcess<T = Type>(model: T) {
    return super.mergeTogetherAndCutExcess(model) as FormType
  }

  static onlyModelKeysDiff<T = Type>(snapshot: T, formModel: T) {
    return super.onlyModelKeysDiff(snapshot, formModel) as Partial<FormType>
  }
}
